import { createFileRoute } from "@tanstack/react-router";
import { requireRoutePermission } from "../../route-authorization";
import { RoutedDashboardPage } from "../../dashboard-page-context";

export const Route = createFileRoute("/app/opportunities")({
  beforeLoad: () => requireRoutePermission("opportunities.view"),
  component: RoutedDashboardPage,
});
